const BASE_URL = "https://assocham.org";

export async function fetchLeadershipInsights() {
  const res = await fetch(`${BASE_URL}/api/get_leadership_insights.php`);

  if (!res.ok) {
    throw new Error(`Leadership Insights API failed: ${res.status}`);
  }

  const json = await res.json();

  if (!json.status) {
    throw new Error("Leadership Insights API returned an error");
  }

  // [{ id, title, text, image, name, designation, link }]
  return json.data;
}